var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.0001L10 12.5001L7.5 10.0001M10 12.5001L10 2.5001M6.25 7.5001H5.83333C3.99238 7.5001 2.5 8.99249 2.5 10.8334L2.5 14.1668C2.5 16.0077 3.99238 17.5001 5.83333 17.5001L14.1667 17.5001C16.0076 17.5001 17.5 16.0077 17.5 14.1668V10.8334C17.5 8.99249 16.0076 7.5001 14.1667 7.5001H13.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.0bf081dc617414f1eb7a56624a73a0a0.svg";
export { ForwardRef as ReactComponent };